import {COTATION} from "utils/config/reference"
import { random , get , isArray } from "lodash"
import moment from "moment"
import "moment-timezone"
import { v4 as uuidv4 } from 'uuid';
import * as Sentry from "@sentry/react";

export const getRandomCotation=(data = COTATION )=>{
    const rendNum=random(0,data.length-1);
    return data[rendNum];
}
const getKey = (sem, year) => (`${sem == 1 ? "semester 1" : "semester 2"} - ${year}`)

const SPECIAL_ORG_IDS = ['e5dcb06f-f78d-457a-bacf-8fa357b38ee2', '37ae9554-0da4-4d62-b04f-ec500b0275a4'];
const ORG_END_DATE_16 = 'e5dcb06f-f78d-457a-bacf-8fa357b38ee2';
const ORG_END_DATE_9 = '37ae9554-0da4-4d62-b04f-ec500b0275a4';

const isSpecialOrg = (parentOrgId) => {
    return parentOrgId && SPECIAL_ORG_IDS.includes(parentOrgId);
}

export const getSem1EndDate = (parentOrgId) => {
    if (parentOrgId === ORG_END_DATE_16) {
        return 16;
    } else if (parentOrgId === ORG_END_DATE_9) {
        return 9;
    }
    return 15;
}

export const getSem2StartDate = (parentOrgId) => {
    if (parentOrgId === ORG_END_DATE_16) {
        return 17;
    } else if (parentOrgId === ORG_END_DATE_9) {
        return 10;
    }
    return 16;
}

export const semeterDateByYear=(year, parentOrgId = null)=>{
    const isSpecial = isSpecialOrg(parentOrgId);
    const yearNum = typeof year === 'string' ? parseInt(year) : year;
    
    if (isSpecial) {
        const sem1EndDay = getSem1EndDate(parentOrgId);
        const sem2StartDay = getSem2StartDate(parentOrgId);
        const sem1StartDate = moment({year: yearNum, month: 7, date: 1, hour: 0, minute: 0, second: 0});
        const sem1EndDate = moment({year: yearNum + 1, month: 0, date: sem1EndDay, hour: 23, minute: 59, second: 59});
        const sem2StartDate = moment({year: yearNum, month: 0, date: sem2StartDay, hour: 0, minute: 0, second: 0});
        const sem2EndDate = moment({year: yearNum, month: 6, date: 15, hour: 23, minute: 59, second: 59});
        return ({
            sem1StartDate,
            sem1EndDate,
            sem2StartDate,
            sem2EndDate
        })
    } else {
        const sem1StartDate = moment({year: yearNum, month: 7, date: 1, hour: 0, minute: 0, second: 0});
        const sem1EndDate = moment({year: yearNum, month: 11, date: 31, hour: 23, minute: 59, second: 59});
        const sem2StartDate = moment({year: yearNum, month: 0, date: 1, hour: 0, minute: 0, second: 0});
        const sem2EndDate = moment({year: yearNum, month: 5, date: 30, hour: 23, minute: 59, second: 59});
        return ({
            sem1StartDate,
            sem1EndDate,
            sem2StartDate,
            sem2EndDate
        })
    }

}
export const getCurrentSameDateRange = (parentOrgId = null) => {
    const current_sem = getCurrenSem(parentOrgId);
    const year = moment().format("YYYY")
    const isSpecial = isSpecialOrg(parentOrgId);
    
    if (current_sem.includes("semester 1")) {
        if (isSpecial) {
            const sem1EndDay = getSem1EndDate(parentOrgId);
            return ({
                from_date: moment().set({ 'year': year, 'month': 7, 'date': 1 }).toISOString(),
                end_date: moment().set({ 'year': parseInt(year) + 1, 'month': 0, 'date': sem1EndDay }).toISOString()
            })
        } else {
            return ({
                from_date: moment().set({ 'year': year, 'month': 7, 'date': 1 }).toISOString(),
                end_date: moment().set({ 'year': year, 'month': 11, 'date': 31 }).toISOString()
            })
        }
    } else {
        if (isSpecial) {
            const sem2StartDay = getSem2StartDate(parentOrgId);
            return ({
                from_date: moment().set({ 'year': year, 'month': 0, 'date': sem2StartDay }).toISOString(),
                end_date: moment().set({ 'year': year, 'month': 6, 'date': 15 }).toISOString()
            })
        } else {
            return ({
                from_date: moment().set({ 'year': year, 'month': 0, 'date': 1 }).toISOString(),
                end_date: moment().set({ 'year': year, 'month': 5, 'date': 30 }).toISOString()
            })
        }
    }
}
export const getCurrenSem=(parentOrgId = null)=>{
    const isSpecial = isSpecialOrg(parentOrgId);
    const today = moment();
    
    if (isSpecial) {
        const sem1EndDay = getSem1EndDate(parentOrgId);
        const sem2StartDay = getSem2StartDate(parentOrgId);
        const sem1StartDate = moment().set({'month':7,'date':1});
        const sem1EndDate = moment().set({'month':0,'date':sem1EndDay});
        const sem2StartDate = moment().set({'month':0,'date':sem2StartDay});
        const sem2EndDate = moment().set({'month':6,'date':15});
        
        if ((today.month() === 7 && today.date() >= 1) || (today.month() >= 8 && today.month() <= 11) || (today.month() === 0 && today.date() <= sem1EndDay)) {
            const year = today.month() === 0 && today.date() <= sem1EndDay ? today.year() - 1 : today.year();
            return getKey(1, year.toString());
        } else {
            return getKey(2, today.format("YYYY"));
        }
    } else {
        const sem1StartDate = moment().set({'month':7,'date':1});
        const sem1EndDate = moment().set({'month':11,'date':31});
        if(today.isSameOrAfter(sem1StartDate,"day") && today.isSameOrBefore(sem1EndDate,"day")){
            return getKey(1,moment().format("YYYY"));
        }
        else {
            return getKey(2,moment().format("YYYY"))
        }
    }
}
export const getDateTime = (obj, key ,defVal) => {
    const datetime = get(obj, key);
    if (typeof datetime == "string") {
        if (datetime.includes("T")) return datetime;
        else if (datetime.length > 0) {
            return `${datetime}T23:59`
        } else {
            return null;
        }
    } else {
        return defVal;
    }
}

export const isBeforTime = (time1,time2,timezone) =>{
    if(typeof  timezone =="string" && timezone.length>0){
        return moment(time1).tz(timezone).isBefore(moment(time2?time2:new Date()).tz(timezone),"minute")
    }else{
        return moment(time1).isBefore(moment(time2 ? time2 : new Date()), "second")
    }
}
export const isAfterTime = (time1,time2,timezone) =>{
  try {
    if(typeof  timezone =="string" && timezone.length>0){
        return moment(time1).tz(timezone).isAfter(moment(time2?time2:new Date()).tz(timezone),"minute")
    }else{
        return moment(time1).isAfter(moment(time2?time2:new Date()),"minute")
    }
  }
  catch (error) {
    console.error("Error comparing times:", error);
    Sentry.captureException(`135 Error during time comparison ${error}.`);
    return false;
  }
}
export const sortMessage = (messages) => {
    if(isArray(messages)){
       return messages.sort((a,b)=>(new Date(a.createdAt) - new Date((b.createdAt))))
    }else{
        return []
    }
}

export function convertToRoman(num) {
    const roman = {
      M: 1000,
      CM: 900,
      D: 500,
      CD: 400,
      C: 100,
      XC: 90,
      L: 50,
      XL: 40,
      X: 10,
      IX: 9,
      V: 5,
      IV: 4,
      I: 1
    };
    let str = '';
    for (let i of Object.keys(roman)) {
      let q = Math.floor(num / roman[i]);
      num -= q * roman[i];
      str += i.repeat(q);
    }
    return str;
  }
export function ValidationOfRomanNumerals(str) {
    let regex = new RegExp(/^M{0,3}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/);
    if (str == null) {
        return false;
    }
    return regex.test(str)
}

function romanvalue(r) {
    if (r == 'I')
        return 1;
    if (r == 'V')
        return 5;
    if (r == 'X')
        return 10;
    if (r == 'L')
        return 50;
    if (r == 'C')
        return 100;
    if (r == 'D')
        return 500;
    if (r == 'M')
        return 1000;
    return -1;
}

function romanToDecimal(str) {
    let res = 0;
    let rmoval = str.toUpperCase()
    for (let i = 0; i < rmoval.length; i++) {
        let s1 = romanvalue(rmoval.charAt(i));
        if (i + 1 < rmoval.length) {
            let s2 = romanvalue(rmoval.charAt(i + 1));
            if (s1 >= s2) {
                res = res + s1;
            }
            else {
                res = res + s2 - s1;
                i++;
            }
        }
        else {
            res = res + s1;
        }
    }
    return res;
}



export const getNextNumberMask = (num,secondLast,pageId=1) => {
    const a_sm = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
    const a_lg = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    if (!isNaN(parseInt(num))) {
        return parseInt(num) + 1
    }
   else if (ValidationOfRomanNumerals(num)&&(ValidationOfRomanNumerals(secondLast)||!isNaN(parseInt(secondLast))||!secondLast)) {
        return convertToRoman(parseInt(romanToDecimal(num)) + 1)
    } 
    else if (a_sm.includes(num)) {
        const num_ind = a_sm.lastIndexOf(num);
        if (num_ind < 25) {
            return a_sm[num_ind + 1]
        } else {
            return pageId;
        }
    }
    else if (a_lg.includes(num)) {
        const num_ind = a_lg.lastIndexOf(num);
        if (num_ind < 25) {
            return a_lg[num_ind + 1]
        } else {
            return pageId;
        }
    }
    else return pageId
}

export const generateRandomLightColor = (opacityValue = 0.8) => {
    const red = Math.floor(Math.random() * 255)
    const green = Math.floor(Math.random() * 255)
    const blue = Math.floor(Math.random() * 255)
    const opacity = opacityValue
    return `rgba(${red}, ${green}, ${blue}, ${opacity})`
}

export const getRandomColorInHexa = () =>{
    return Math.floor(Math.random()*16777215).toString(16);
}

export const sortname = (a, b) => {
    const nameA = a?.lastName?.toLowerCase()?.replace(/\s/g, '');
    const nameB = b?.lastName?.toLowerCase()?.replace(/\s/g, '');;
    if (nameA < nameB) { return -1 }
    else if (nameA > nameB) { return 1 }
    else { return 0 }
}

export const  isValidColorCode = (colorCode)=> {
    // Hexadecimal color regex pattern (e.g., #RRGGBB or #RGB)
    const hexRegex = /^#(?:[0-9a-fA-F]{3}){1,2}$/;
  
    // RGB color regex pattern (e.g., rgb(255, 0, 0))
    const rgbRegex = /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/;
  
    // RGBA color regex pattern (e.g., rgba(255, 0, 0, 0.5))
    const rgbaRegex = /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*((1(\.0)?)|(0(\.\d+)?))\)$/;
  
    // Check if it matches the hexadecimal color code pattern
    if (hexRegex.test(colorCode)) {
      return true;
    }
  
    // Check if it matches the RGB color code pattern
    if (rgbRegex.test(colorCode)) {
      // Extract RGB values from the color code
      const [, r, g, b] = colorCode.match(rgbRegex);
      // Check if each value is within the valid range (0-255)
      if (Number(r) >= 0 && Number(r) <= 255 &&
          Number(g) >= 0 && Number(g) <= 255 &&
          Number(b) >= 0 && Number(b) <= 255) {
        return true;
      }
    }
  
    // Check if it matches the RGBA color code pattern
    if (rgbaRegex.test(colorCode)) {
      const [, r, g, b, a] = colorCode.match(rgbaRegex);
      if (Number(r) >= 0 && Number(r) <= 255 &&
          Number(g) >= 0 && Number(g) <= 255 &&
          Number(b) >= 0 && Number(b) <= 255 &&
          (Number(a) >= 0 && Number(a) <= 1)) {
        return true;
      }
    }
    return false;
  }

  
  export const getCurrentSemStartAndEndDate = (parentOrgId = null) => {
    const isSpecial = isSpecialOrg(parentOrgId);
    const today = moment();
    
    if (isSpecial) {
        const sem1EndDay = getSem1EndDate(parentOrgId);
        const sem2StartDay = getSem2StartDate(parentOrgId);
        const sem1StartDate = moment().set({ 'month': 7, 'date': 1, 'hour': 0, 'minute': 0 });
        const sem1EndDate = moment().set({ 'month': 0, 'date': sem1EndDay, 'hour': 23, 'minute': 59 });
        const sem2StartDate = moment().set({ 'month': 0, 'date': sem2StartDay, 'hour': 0, 'minute': 0 });
        const sem2EndDate = moment().set({ 'month': 6, 'date': 15, 'hour': 23, 'minute': 59 });
        
        if ((today.month() === 7 && today.date() >= 1) || (today.month() >= 8 && today.month() <= 11) || (today.month() === 0 && today.date() <= sem1EndDay)) {
            const year = today.month() === 0 && today.date() <= sem1EndDay ? today.year() - 1 : today.year();
            return ({
                start: sem1StartDate.year(year),
                end: sem1EndDate.year(today.year())
            });
        } else {
            return ({
                start: sem2StartDate.year(today.year()),
                end: sem2EndDate.year(today.year())
            });
        }
    } else {
        const sem1StartDate = moment().set({ 'month': 7, 'date': 1, 'hour': 0, 'minute': 0 });
        const sem1EndDate = moment().set({ 'month': 11, 'date': 31, 'hour': 23, 'minute': 59 });
        const sem2StartDate = moment().set({ 'month': 0, 'date': 1, 'hour': 0, 'minute': 0 });
        const sem2EndDate = moment().set({ 'month': 5, 'date': 30, 'hour': 23, 'minute': 59 });
        if (today.isSameOrAfter(sem1StartDate, "day") && today.isSameOrBefore(sem1EndDate, "day")) {
            return ({
                start: sem1StartDate,
                end: sem1EndDate
            });
        } else {
            return ({
                start: sem2StartDate,
                end: sem2EndDate
            });
        }
    }
}

export const getFormattedTime = () => {
    const date = new Date();
    let hour = date.getHours();
    const minute = date.getMinutes().toString().padStart(2, '0');
    const period = hour >= 12 ? 'PM' : 'AM';
    
    hour = hour % 12;
    hour = hour ? hour : 12;
    
    return { hour: hour.toString(), minute: minute.toString(), period };
  };


// export const isIOS = () => {
//     return [
//         'iPad Simulator',
//         'iPhone Simulator',
//         'iPod Simulator',
//         'iPad',
//         'iPhone',
//         'iPod'
//     ].includes(navigator.platform)
//         // iPad on iOS 13 detection
//         || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
// };


export const isMobileDevice = () => {
    const isIOS = [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document);

    const isAndroidMobile = /Android/i.test(navigator.userAgent) && /Mobile/i.test(navigator.userAgent);
    const isAndroidTablet = /Android/i.test(navigator.userAgent) && !/Mobile/i.test(navigator.userAgent);
    if (isIOS || isAndroidMobile || isAndroidTablet) {
        return true;
    }
    else{
        return false;
    }
};

export const testValidUrl = (url) => {
    const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
    return urlRegex.test(url);
}


export const getSizeInKBMb = (size) => {
    if(size){
        const bytes = size;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        const imageSize = Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
        return imageSize;
    }
}

export const checkBookId = (
  compareValue,
  maxValue,
  parseValue = 10,
  compare = "lessThan"
) => {
  switch (compare) {
    case "lessThan":
      return parseInt(compareValue, 10) < parseInt(maxValue, parseValue);
    case "greaterThan":
      return parseInt(compareValue, 10) > parseInt(maxValue, parseValue);
    default:
      return null;
  }
};

export const  isLate = (lateDate, dueDate) => {
    const late = new Date(lateDate);
    const due = new Date(dueDate);

    return late > due;
}

export  const isPastDue = (_quiz,servertime,timezone) => {
    if (_quiz && _quiz.lateDate && isLate(_quiz.lateDate,_quiz.dueDate)) {
      return isBeforTime(_quiz.lateDate, servertime, timezone);
    } else if (_quiz && _quiz.dueDate && !isLate(_quiz.lateDate,_quiz.dueDate)) {
      return isBeforTime(_quiz.dueDate, servertime, timezone);
    } else {
      return false;
    }
  };

  export const checkAllCorrect = (data, max_mark_per_question) => {
    let correct = 0;
    let total = 0;
    if (!data || typeof data !== 'object') {
        return ({
          all_corect: false,
          correct,
          total,
          mark: 0
      });
    }
    const answerArrays = Object.values(data);
    if (answerArrays.length === 0) {
        return ({
          all_corect: false,
          correct,
          total,
          mark: 0
        });
    }
    answerArrays.forEach(answers => {
        if (Array.isArray(answers) && answers.length > 0) {
            answers.forEach(answer => {
                total += 1;
                if (answer?.is_correct === true) {
                    correct += 1;
                }
            });
        }
    });
    const mark = total > 0
        ? Number((Number.parseFloat(max_mark_per_question) / total) * correct).toFixed(2)
        : 0;
    return ({
        all_corect: correct === total && total > 0,
        correct,
        total,
        mark
    });
};



export const checkAllCorrectMatch = (data, max_mark_per_question, options) => {
  let total = 0;
  let correct = 0;
  
  if (!Array.isArray(data)) {
    console.error("Data is not an array", data);
    return ({
      all_corect: false,
      correct: 0,
      total: 0,
      mark: 0
    });
  }

  if (!Array.isArray(options) || options.length === 0) {
    total = data.length;
    data.forEach(answer => {
      if (answer.is_correct === true) {
        correct++;
      }
    });
  } else {
    total = options.length;
    data.forEach(studentAnswer => {
      const targetIndex = studentAnswer.item;
      const matchedItemIndex = studentAnswer.match_item;
      
      if (targetIndex !== undefined && matchedItemIndex !== undefined) {
        if (targetIndex === matchedItemIndex) {
          correct++;
        }
      }
    });
  }

  return ({
    all_corect: correct === total && total > 0,
    correct,
    total,
    mark: total > 0 ? Number((Number.parseFloat(max_mark_per_question) / total) * correct).toFixed(2) : 0
  });
};
  
  
  export const  filterDuplicateWords = (items) => {
    const highlightWords = new Set(
      items
        .filter(item => item.type === 'highlight')
        .map(item => item.text.toLowerCase())
    );
  
    return items.filter(item => {
      if (item.type === 'highlight') {
        return true;
      }
      
      if (item.type === 'custom') {
        return !highlightWords.has(item.text.toLowerCase());
      }
      return true;
    });
  };

  export const removeCustomDuplicates = (array) => {
    const seen = new Set();
    return array.filter(item => {
      // Keep all non-custom type items
      if (item.type !== 'custom') {
        return true;
      }
      
      // For custom type items, check for duplicates
      const itemText = item.text.toLowerCase();
      if (!seen.has(itemText)) {
        seen.add(itemText);
        return true;
      }
      return false;
    });
  };

  export const hasEmptyAnswers = (data) => {
    try{
        if (!data) {
            return true;
          }
        
          // Handle array cases
          if (Array.isArray(data)) {
            // Case 1: Single-level array of answer objects
            if (data.length > 0 && !Array.isArray(data[0])) {
              return data.some(element => 
                !element?.answer || element.answer.trim() === ""
              );
            }
            
            // Case 2: Nested array of answer objects
            return data.some(group => {
              if (!Array.isArray(group)) return true;
              return group.some(element => 
                !element?.answer || element.answer.trim() === ""
              );
            });
          }
        
          if (typeof data === "object" && Object.keys(data).length > 0) {
            for (const questionGroup in data) {
              const answers = data[questionGroup];
              
             
              if (!Array.isArray(answers) || answers.length === 0) {
                return true;
              }
        
              const hasEmpty = answers.some(item => 
                !item || 
                typeof item !== "object" || 
                !("answer" in item) || 
                item.answer.trim() === ""
              );
        
              if (hasEmpty) {
                return true;
              }
            }
        
            return false;
          }
          return true;

    }catch(error){
        console.log(error);
    }
  };


  export const combineRectangles = (dataArray) => {
    if (dataArray) {
      // Filter out entries with show: false and validate data structure
      const validEntries = dataArray?.filter(
        (entry) =>
        entry.data && Array.isArray(entry.data.rectangles)
      );

      // Sort entries by created_at in ascending order (oldest first)
      const sortedEntries = validEntries.sort(
        (a, b) => new Date(a.created_at) - new Date(b.created_at)
      );

      // Combine all rectangles with additional metadata
      const combinedRectangles = sortedEntries.reduce((acc, entry) => {
        const rectanglesWithMetadata = entry.data.rectangles.map((rect) => ({
          ...rect,
          // Preserve the non_native flag from either the rectangle or the parent entry
          non_native: rect.non_native || entry.non_native || false,
          // Add metadata from parent entry
          userId: entry.user_id,
          entryId: entry.id,
          createdAt: entry.created_at,
        }));
        return [...acc, ...rectanglesWithMetadata];
      }, []);

      // Get natural dimensions from the first valid entry
      const naturalDimensions = sortedEntries[0]?.data.naturalDimensions || {
        width: 0,
        height: 0,
      };

      return {
        rectangles: combinedRectangles || [],
        naturalDimensions,
      };
    }
  };


export const  checkIsTbgTxt = (current_assignment_grade) => {
  if (current_assignment_grade && typeof current_assignment_grade === "string" && current_assignment_grade.includes) {
      return current_assignment_grade?.includes('TBG')
  }
  return false;
}

const QUESTION_TYPES = {
  MULTIPLE_CHOICE: 'multipleChoice',
  ESSAY: 'essay',
  EMAIL:'email',
  AUDIO: 'audio',
  VIDEO: 'video',
  FILLING: 'filling',
  PICTURE: 'picture',
  TWO_MINT_AUDIO: 'twoMinAudio',
  FILLINGGIMAGE: 'fillingImage',
  TRUE_FALSE: 'trueFalse',
  AUDIO_TRUE_FALSE: 'audioTrueFalse',
  AUDIO_MULTI_CHOICE: 'audioMultipleChoice',
  MATCH: 'match',
  AUDIO_ESSAY:"audioEssay",
  PHOTOCOLLAGE: "photoCollage",
  AUDIO_TO_IMAGE: "audioToImage",
  MULTIPLE_RESPONSE: 'multipleResponse',
};
export const checkIsManualGradable = (questions) => {
  if (Array.isArray(questions) && questions.length > 0) {
    return questions.some((question) => 
      question.type == QUESTION_TYPES.AUDIO 
    || question.type == QUESTION_TYPES.VIDEO 
    || question.type == QUESTION_TYPES.PICTURE 
    || question.type == QUESTION_TYPES.TWO_MINT_AUDIO
    || question.type == QUESTION_TYPES.ESSAY 
    || question.type == QUESTION_TYPES.EMAIL
    || question.type == QUESTION_TYPES.AUDIO_ESSAY 
    || question.type == QUESTION_TYPES.PHOTOCOLLAGE 
    || question.type == QUESTION_TYPES.AUDIO_TO_IMAGE
  );
  }
  return false;
}
export const checkHasAutoGrade = (questions)=>{
   if (Array.isArray(questions) && questions.length > 0) {
    return questions.some((question) => 
      question.type == QUESTION_TYPES.MULTIPLE_CHOICE 
    || question.type == QUESTION_TYPES.TRUE_FALSE 
    || question.type == QUESTION_TYPES.MATCH 
    || question.type == QUESTION_TYPES.AUDIO_MULTI_CHOICE
    || question.type == QUESTION_TYPES.AUDIO_TRUE_FALSE 
    || question.type == QUESTION_TYPES.FILLINGGIMAGE
    || question.type == QUESTION_TYPES.MULTIPLE_RESPONSE
  );
  }
  return false;
}
export const generateShortUUID = ()  => {
  const fullUUID = uuidv4();
  return fullUUID.split('-')[0];
}



export const isGradedByTeacher = (submission, is_past) => {
  if (!submission) return ''
  if (!is_past && submission.manualGrading) return ''
  if (submission && submission.graded_by_teacher) {
    return `(Graded by teacher)`
  }
  return ''
}

export function findSectionByPageId(sections, pageId) {
  // Handle negative page IDs by converting to positive
  const absPageId = Math.abs(pageId);
  
  // Find the section where absPageId falls between start and finish values
  const foundSection = sections.find(section => {
    const start = parseInt(section.start, 10);
    const finish = parseInt(section.finish, 10);
    
    return absPageId >= start && absPageId <= finish;
  });
  
  return foundSection || null;
}

export function isDueDatePassed(dueDate) {
  // Get current time
  const currentTime = new Date();
  
  // Parse the due date
  const dueDateObj = new Date(dueDate);
  
  // Compare: return true if due date has passed (is before or equal to current time)
  return dueDateObj <= currentTime;
}


export function filterActiveTasks(dataArray) {
  return dataArray.filter((item) => {
    if (item?.dueDate) {
      return !isDueDatePassed(item.dueDate);
    } else if(!item?.dueDate || item?.dueDate?.length === 0){
      return false;
    }
    else{
      return true;
    }
  });
}

export const disableBodyScroll = (from = 'unknown') => {
  document.body.style.overflow = 'hidden';
  // console.log(`Body scroll disabled from: ${from}`);
};

export function getDiffConfigForStudent(userId, assignment, classId) {
  if (!userId || !assignment || !classId) return null;
  const classConfig = assignment.classes?.find(c => c.id === classId);
  const groups = classConfig?.diff?.groups || []
  if (!Array.isArray(groups) || !groups.length) return null;
  const filteredGroups = groups.filter(group => {
    const includes = group.student?.includes(userId) || group.student?.includes(String(userId)) || group.student?.some(s => String(s) === String(userId));
    return includes;
  });

  if (filteredGroups.length > 0) {
    const groupWithMaxDueDate = filteredGroups.reduce((latest, current) => {
      return new Date(current.dueDateDif) > new Date(latest.dueDateDif) ? current : latest;
    });
    return groupWithMaxDueDate;
  }
  return null;
}

export function memoize(fn) {
  const cache = {};

  return function (...args) {
    const key = String(args);

    if (key in cache) {
      return cache[key];
    }

    const result = fn(...args);
    cache[key] = result;
    return result;
  };
}
  export const dispalayRole = (value) => {
    switch (value) {
      case 'owe_admin':
        return 'Admin';
      default:
        return value;
    }
  };

  export const checkContentOnHtml = (value) => {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = value;

    const textContent = tempElement.textContent || tempElement.innerText;
    return textContent?.length === 0;
  };

  export function debounceMath(func, delay) {
      let timeoutId;
      return function (...args) {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => func.apply(this, args), delay);
      };
  }
export function validateObjectData(obj, requiredFields) {
  // If no required fields specified, use default
  if (!requiredFields) {
    requiredFields = [
      'word',
      'antonyms',
      'sentence',
      'synonyms',
      'definition',
      'sentence_english',
      'english_translation'
    ];
  }

  // Check if object exists
  if (!obj || typeof obj !== 'object') {
    return { valid: false };
  }

  // Check if ANY field is empty
  for (const field of requiredFields) {
    const value = obj[field];
    
    // Missing field
    if (!(field in obj)) {
      return { valid: false };
    }
    
    // Null or undefined
    if (value === null || value === undefined) {
      return { valid: false };
    }
    
    // Empty string
    if (typeof value === 'string' && value.trim() === '') {
      return { valid: false };
    }
    
    // Empty array - if ANY array is empty, return false
    if (Array.isArray(value) && value.length === 0) {
      return { valid: false };
    }
  }
  
  return { valid: true };
}

export const LEVELS = [
  {
      id: '1',
      value: 'easy',
      label: '2'
  },
  {
      id: '2',
      value: 'medium',
      label: '3'
  },
  {
      id: '3',
      value: 'hard',
      label: '4'
  },
  {
      id: '4',
      value: 'very_hard',
      label: '5'
  },
  {
      id: '5',
      value: 'extreme',
      label: '6'
  },
  {
      id: '6',
      value: 'challenging',
      label: '7'
  },
  {
      id: '7',
      value: 'advanced',
      label: '8'
  },
  {
      id: '8',
      value: 'expert',
      label: '9'
  }
]
export const isScheduledToday = (scheduleAt) => {
  return moment(scheduleAt).isSame(moment(), 'day');
};
export const af_grade = (value) => {
  const g = parseInt(value);
  if (g >= 0 && g <= 20) return 'F';
  else if (g <= 40) return 'D';
  else if (g <= 60) return 'C';
  else if (g <= 80) return 'B';
  else if (g > 80) return 'A';
  else return "-";
}

export const getLevels = (max_marks) => {
  const nativos1_end = Math.floor(max_marks * 0.2727);
  const nativos2_end = nativos1_end + Math.floor(max_marks * 0.3636);
  const nativos3_end = nativos2_end + Math.floor(max_marks * 0.2727);
  const ap_end = max_marks; // Remainder goes to AP Spanish

  return [
    {
      legend: `Nativos 1 (0–${nativos1_end} puntos): El estudiante muestra un conocimiento inicial o limitado del español. Necesita apoyo intensivo para mejorar su fluidez y comprensión básica.`,
      color: "#003366",
      range: [0, nativos1_end]
    },
    {
      legend: `Nativos 2 (${nativos1_end + 1}–${nativos2_end} puntos): El estudiante tiene una comprensión moderada y puede comunicarse con limitaciones. La instrucción dirigida y práctica continua son claves.`,
      color: "#f58d1d",
      range: [nativos1_end + 1, nativos2_end]
    },
    {
      legend: `Nativos 3 (${nativos2_end + 1}–${nativos3_end} puntos): El estudiante maneja el idioma con buena fluidez y pocas restricciones. Puede beneficiarse de enseñanza en aspectos complejos.`,
      color: "#40a9ff",
      range: [nativos2_end + 1, nativos3_end]
    },
    {
      legend: `AP Spanish (${nativos3_end + 1}–${ap_end} puntos): El estudiante demuestra un dominio avanzado del español, apto para desafíos lingüísticos y discusiones académicas complejas.`,
      color: "#a084ca",
      range: [nativos3_end + 1, ap_end]
    }
  ];
};

export const formatValueDisplayForVocab = (val) => {
  if (Array.isArray(val)) return val.join(', ');
  return String(val || '').replace(/,\s*/g, ', ');
}